<template>
  <f7-page>
    <f7-navbar title="楊枝金撈食材下單系統"></f7-navbar>

    <f7-block class="text-align-center" v-if="!loaded">
      <f7-preloader :size="36"></f7-preloader>
    </f7-block>

    <template v-if="loaded && loggedIn">
      <f7-block>
        <h2>
          你好 Hello!<br>{{ user_info.name }}

          (<span style="font-size: 15px">{{ userTypeDisplay }}</span>)
        </h2>
      </f7-block>
    </template>

    <template v-if="loaded && loggedIn && (type === 'store' || type === 'manager' || type === 'customer')">
      <f7-block>
        <f7-button @click="createOrder" large raised>新建訂單 Create Order</f7-button>
      </f7-block>

      <f7-block>
        <f7-button href="/store/order/histories/" large raised>歷史訂單 Order Histories</f7-button>
      </f7-block>
    </template>

    <template v-if="loaded && loggedIn && type === 'warehouse'">
      <f7-block>
        <f7-button href="/warehouse/orders/" large raised>訂單列表 Order List</f7-button>
      </f7-block>
      <f7-block>
        <f7-button href="/warehouse/products/" large raised>庫存管理 Inventory</f7-button>
      </f7-block>
    </template>

    <template v-if="loaded && loggedIn">
      <f7-block>
        <f7-button @click="logout" large raised>登出 Logout</f7-button>
      </f7-block>
    </template>

    <template v-if="loaded && !loggedIn">
      <f7-block>
        <f7-button href="/login/" large raised>登入 Login</f7-button>
      </f7-block>
    </template>
  </f7-page>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loaded: false,
      loggedIn: false,
      type: null,
      user_info: {},
    }
  },
  computed: {
    userTypeDisplay() {
      switch (this.type) {
        case 'store':
          return '商店帳號 Store Account'
        case 'warehouse':
          return '工場帳號 Warehouse Account'
        case 'manager':
          return '經理帳號 Manager Account'
        case 'customer':
          return '顧客帳號 Customer Account'
        default:
          return '--'
      }
    }
  },
  mounted() {
    axios.get('/api/user')
      .then(({ data }) => {
        this.loaded = true
        this.loggedIn = true
        this.type = data.role.toLowerCase()
        this.user_info = data
      })
      .catch(() => {
        this.loaded = true
        this.loggedIn = false
        this.type = null
        this.user_info = {}
      })
  },
  methods: {
    createOrder() {
      localStorage.removeItem('categories_draft')
      localStorage.removeItem('categories_products_draft')

      this.$f7router.navigate('/store/products/')
    },
    logout() {
      axios.post('/logout').then(() => {
        this.$nextTick(() => {
          window.location = '/'
        })
      })
    },
    print() {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        foo: 'bar',
      }))
    }
  }
}
</script>
